import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import cls from 'classnames';
import styles from './RequiredMark.module.less';
function RequiredMark(props) {
    const { className } = props;
    return _jsx("span", { className: cls(styles.requiredMark, className), children: "*" });
}
export default observer(RequiredMark);
